import { isRu } from "services/region/region";
import React, { useContext, useEffect, useState } from "react";
import { LogoutOutlined, SelectOutlined, SettingOutlined } from "@ant-design/icons";
import {
  Avatar, Col, Dropdown, Layout, Menu, MenuProps, Row, Space,
} from "antd";
import Keycloak from "keycloak-js";
import { useIntl } from "react-intl";
import { Link, useLocation } from "react-router-dom";

import { useKeycloak } from "services/keycloak/hook";
import AccountLogo from "assets/logo/logo.svg";

import "./AccountHeader.less";
import { ItemType } from "antd/lib/menu/hooks/useItems";
import { env } from "config";

const storeUrl = env.REACT_APP_JMIX_STORE_FRONTEND_URL;

export function AccountHeader() {
  const [name, setName] = useState("U");
  const keycloak = useKeycloak();
  const intl = useIntl();

  useEffect(() => {
    keycloak.loadUserProfile().then(() => {
      setName(getAvatarName(keycloak?.profile));
    });
  });

  const avatarMenuItems: ItemType[] = [
    {
      key: "/settings/contact-info",
      icon: <SettingOutlined />,
      label: <Link to="/settings/contact-info">{intl.formatMessage({ id: "jmix-store.header.setting" })}</Link>,
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: intl.formatMessage({ id: "jmix-store.header.logout" }),
      onClick: () => keycloak.logout({ redirectUri: window.location.origin }),
    }
  ];

  const items: ItemType[] = [
    {
      key: "/account",
      label: <a href={`${storeUrl}/account`}>{intl.formatMessage({ id: "jmix-store.header.account" })}</a>,
    },
    {
      key: "/billing-info",
      label: <a href={`${storeUrl}/billing-info`}>{intl.formatMessage({ id: "jmix-store.header.billing-info" })}</a>,
    },
    {
      key: "/",
      label: <a href={`${storeUrl}/`}>{intl.formatMessage({ id: "jmix-store.header.store" })}</a>,
    }
  ];

  return (
    <Layout.Header className="store-header">
      <Layout className="store-header__container">
        <Row
          className="store-header__row"
          wrap={false}
        >
          <Col flex="150px">
            <div className="store-header__logo">
              <a href={`${storeUrl}/account`}>
                <img
                  src={AccountLogo}
                  alt="Account Logo"
                />
              </a>
            </div>
          </Col>
          <Col flex="1 1 200px">
            <Menu
              theme="light"
              mode="horizontal"
              className="store-header__menu"
              items={items}
            />
          </Col>
          <Col flex="100px">
            <a
              href={isRu() ? "https://www.jmix.ru" : "https://jmix.io"}
              className="store-header__jmix"
            >
              <Space>
                <SelectOutlined />
                <span>{isRu() ? "jmix.ru" : "jmix.io"}</span>
              </Space>
            </a>
          </Col>
          <Col flex="50px">
            <Space className="store-header__avatar">
              <Dropdown
                overlay={<Menu items={avatarMenuItems} />}
              >
                <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>{name}</Avatar>
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </Layout>
    </Layout.Header>
  );
}

function getAvatarName(profile: Keycloak.KeycloakProfile | undefined): string {
  if (profile) {
    const { firstName, lastName } = profile;

    let name = "";
    if (firstName) {
      name += firstName.charAt(0).toUpperCase();
    }

    if (lastName) {
      name += lastName.charAt(0).toUpperCase();
    }
    return name;
  }

  return "U";
}
